import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject ,  Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Configuration } from '../../app.constants';
import { IonicAngular4CacheService } from 'ionic-angular4-cache';

@Injectable()
export class OrganizationService {
  public hrLeaderId: string;
  public companyLeaderId: string;
  public organizationId: string;
  public companyName: string;
  public hrTeamIds = [];

  constructor(
    private _http: HttpClient,
    private config: Configuration,
    public ionicAngular4Cache: IonicAngular4CacheService
  ) { }

  public search(skip, limit, query, sort) {
    return new Promise((ok, notOk) => {
      const queryData = { 'query': query, 'sort': sort };
      const searchOrganizationObservable = this._http.post(`${this.config.ServerApiUrl}/organization/search/${skip * limit}/${limit}`,
      queryData);
      searchOrganizationObservable.subscribe(data => {
        this.ionicAngular4Cache.saveItemOld(`organizationSearch`, data);
        ok(data);
      });
    });
  }

  public powerSearch(skip, limit, query, sort) {
    return new Promise((ok, notOk) => {
      const queryData = { 'query': query, 'sort': sort };
      const searchOrganizationObservable = this._http.post(`${this.config.ServerApiUrl}/organization/powersearch/${skip * limit}/${limit}`,
      queryData);
      searchOrganizationObservable.subscribe(data => {
        this.ionicAngular4Cache.saveItemOld(`organizationSearch`, data);
        ok(data);
      });
    });
  }

  public getAllOrganizationsFilter (name: string) {
    return this._http.get(`${this.config.ServerApiUrl}/organization/readAllReg?name=${name}`);
  }

  public createOrganization(organization: any) {
    if (organization != null) {
      return this._http.post(`${this.config.ServerApiUrl}/organization/create`, organization);
    }
  }

  public getOrganization(id?: String) {
    if (id != null) {
      this._http.get(`${this.config.ServerApiUrl}/organization/read?id=${id}`).subscribe(data => {
        console.log('getOrganization data', data);
      }, error => {

      });
      return this._http.get(`${this.config.ServerApiUrl}/organization/read?id=${id}`);
    } else {
      return this._http.get(`${this.config.ServerApiUrl}/organization/read`) ;
    }
  }
  public getAllOrganizations(skip: any, limit: any) {
    return this._http.get(`${this.config.ServerApiUrl}/organization/read/${skip}/${limit}`);
  }

  public markOrganizationAsInactive(id: String, archivedBy) {
    if (id != null) {
        return this._http.post(`${this.config.ServerApiUrl}/organization/delete`, {'idToDelete' : id, 'archivedBy': archivedBy})
    }
}

  public updateOrganization(organization: any) {
    return this._http.put(`${this.config.ServerApiUrl}/organization/update`, organization);
  }

  public bulkArchive(organizations, query?) {
    if (query) {
      return this._http.post(`${this.config.ServerApiUrl}/organization/bulkArchive`, { 'idsToDelete': organizations, 'query' : query});
    } else {
      return this._http.post(`${this.config.ServerApiUrl}/organization/bulkArchive`, { 'idsToDelete': organizations});
    }
  }

  public getOpcoCountries () {
    return this._http.post(`${this.config.ServerApiUrl}/organization/getOpcoCountries`, {});
  }

  public getSiteCountries () {
    return this._http.post(`${this.config.ServerApiUrl}/site/getSiteCountries`, {});
  }

  public getOpcoAssociatesHeirarchy (organizationId) {
    // console.log('Organization ID from service',  );
    if (organizationId !== '') {
      return this._http.post(`${this.config.ServerApiUrl}/organization/getHeirarchyAssociates`, {'organizationId': organizationId });
    }
  }

  // Legal Entities
  public getLegalEntity(entityId?: string) {
    if (entityId != null) {
      return this._http.get(`${this.config.ServerApiUrl}/legal-entity/read?id=${entityId}`);
    }
  }
  public getLegalEntities(organizationId?: string) {
    if (organizationId != null) {
      return this._http.get(`${this.config.ServerApiUrl}/legal-entity/read?organizationId=${organizationId}`);
    }
  }

  public getAllLegalEntities(skip, limit, query, sort) {
    let queryData = { 'query': query, 'sort': sort };
    return this._http.post(`${this.config.ServerApiUrl}/legal-entity/search/${skip * limit}/${limit}`, queryData);
  }

  public powergetAllLegalEntities(skip, limit, query, sort) {
    let queryData = { 'query': query, 'sort': sort };
    return this._http.post(`${this.config.ServerApiUrl}/legal-entity/powersearch/${skip * limit}/${limit}`, queryData);
  }

  public createLegalEntity(legalEntity: any) {
    if (legalEntity) {
      return this._http.post(`${this.config.ServerApiUrl}/legal-entity/create`, legalEntity);
    }
  }

  public updateLegalEntity(legalEntity: any) {
    if (legalEntity) {
      return this._http.put(`${this.config.ServerApiUrl}/legal-entity/update`, legalEntity);
    }
  }

  public markEntityAsInative(entityId: string) {
    if ( entityId ) {
      return this._http.post('api/legal-entity/delete', {'idToDelete': entityId});
    }

  }

  public bulkArchiveLegalEntities(legalEntities, query?) {
    if (query) {
      return this._http.post(`${this.config.ServerApiUrl}/legal-entity/bulkArchive`, { 'idsToDelete': legalEntities, 'query': query});
    } else {
      return this._http.post(`${this.config.ServerApiUrl}/legal-entity/bulkArchive`, { 'idsToDelete': legalEntities});
    }
  }

  // -------- ali haider work start

  public getReportingOrganizationTopStats(query) {
      return this._http.post(`${this.config.ServerApiUrl}/reporting/companiesTopStats`, query);
  }

  public getSiteDistributionData(query) {
      return this._http.post(`${this.config.ServerApiUrl}/reporting/getSiteDistributionData`, query);
  }

  public getSitesForMap(query) {
    return this._http.post(`${this.config.ServerApiUrl}/reporting/getSitesForMap`, query);
  }

  public getAllSites() {
    return this._http.get(`${this.config.ServerApiUrl}/site/getAllsite`);
  }

  // -------- ali haider work end

  public addLegalEntityToOrganization(legalEntity, organizationId) {
    return this._http.post(`${this.config.ServerApiUrl}/legal-entity/addToOrganization`, {'legalEntity': legalEntity,
    'organizationId': organizationId });
  }

  public removeLegalEntityFromOrganization(legalEntityId, organizationId) {
    return this._http.post(`${this.config.ServerApiUrl}/legal-entity/removeFromOrganization`, {'legalEntityId': legalEntityId,
    'organizationId': organizationId });
  }

  public getLegalEntityOrganizations(legalEntityId) {
    return this._http.post(`${this.config.ServerApiUrl}/legal-entity/getLegalEntityOrganization`, {'legalEntityId': legalEntityId});
  }

  public getLegalEntityCountries () {
    return this._http.get(`${this.config.ServerApiUrl}/legal-entity/getLegalEntityCountries`);
  }

  // Sites
  public getSite(siteId: string) {
    if ( siteId ) {
      return this._http.get(`${this.config.ServerApiUrl}/site/read?id=${siteId}`);
    }
  }

  public getSites(organizationId?: string) {
    if ( organizationId ) {
      return this._http.get(`${this.config.ServerApiUrl}/site/read?organizationId=${organizationId}`);
    }
  }

  public getSiteCount() {
    return this._http.get(`${this.config.ServerApiUrl}/site/count`);
}

  public createSite(site: any) {
    if (site) {
      return this._http.post(`${this.config.ServerApiUrl}/site/create`, site);
    }
  }

  public updateSite(site: any) {
    if (site) {
      return this._http.put(`${this.config.ServerApiUrl}/site/update`, site);
    }
  }
  public markSiteAsInactive(id: string,organizationId) {
    if (id) {
      return this._http.post(`${this.config.ServerApiUrl}/site/delete`, {'idToDelete': id,'organizationId': organizationId});
    }
  }

  public searchSites(skip, limit, query, sort) {
    let queryData = { 'query': query, 'sort': sort };
    return this._http.post(`${this.config.ServerApiUrl}/site/search/${skip * limit}/${limit}`, queryData);
  }

  public powersearchSites(skip, limit, query, sort) {
    let queryData = { 'query': query, 'sort': sort };
    return this._http.post(`${this.config.ServerApiUrl}/site/powersearch/${skip * limit}/${limit}`, queryData);
  }

public unarchiveSite(siteId) {
  if (siteId) {
    return this._http.post(`${this.config.ServerApiUrl}/site/unarchive`, {'siteId': siteId});
  }
}

public bulkArchiveSites(sites, query?) {
  if (query) {
    return this._http.post(`${this.config.ServerApiUrl}/site/bulkArchive`, { 'idsToDelete': sites, 'query': query});
  } else  {
    return this._http.post(`${this.config.ServerApiUrl}/site/bulkArchive`, { 'idsToDelete': sites});
  }
}

  // Teams
  public createTeam(organizationId: string , team: any ) {
    if ( team ) {
      return this._http.post(`${this.config.ServerApiUrl}/team/create`, {'organizationId': organizationId, 'team' : team});
    }
  }
  public readTeams(organizationId: string, teamId?: string) {
    if (organizationId && teamId == null) {
       return this._http.get(`${this.config.ServerApiUrl}/team/read?organizationId=${organizationId}&&teamId=`);
    } else {
      return this._http.get(`${this.config.ServerApiUrl}/team/read?organizationId=${organizationId}&&teamId=${teamId}`);
    }
  }

  public updateTeam(organizationId: string, teamId: string, team: any, originalAssociates?: any ) {
    return this._http.put(`${this.config.ServerApiUrl}/team/update`, {'organizationId': organizationId, 'teamId': teamId, 'team': team,
     'origAssc': originalAssociates });
  }

  public deleteTeam (organizationId: string, teamId: string) {
    return this._http.post(`${this.config.ServerApiUrl}/team/delete`, {'organizationId': organizationId, 'teamId': teamId });
  }

  public teamSearch (searchText: string) {
    return this._http.post(`${this.config.ServerApiUrl}/team/search`, {'search': searchText });
  }

  public updateTeamParents (organizationId: string , teams ) {
    return this._http.post(`${this.config.ServerApiUrl}/team/updateParent`, {'organizationId': organizationId, 'teams': teams });
  }
  public getLastValidatedCard(organizationId, cardName) {
    return this._http.post(`${this.config.ServerApiUrl}/organization/validatedCard`, {organizationId: organizationId, cardName: cardName});
  }
  public getAllLegalEntitiesCompanyContext(organizationId) {
    return this._http.get(`${this.config.ServerApiUrl}/legal-entity/getAllLegalEntities?organizationId=${organizationId}`);
  }

  public addInHrTeamCompany(hrId, companyId) {
    return this._http.post(`${this.config.ServerApiUrl}/organization/addInHrTeam`, {'hrId': hrId, 'companyId': companyId});
  }

  public removenHrTeamCompany(hrId, companyId) {
    return this._http.post(`${this.config.ServerApiUrl}/organization/removeHrTeam`, {'hrId': hrId, 'companyId': companyId});
  }

  public getAssociatesCompaniesHrTeamMapping(asscID) {
    return this._http.get(`${this.config.ServerApiUrl}/organization/getAssociatesCompaniesHrTeamMapping?assocId=${asscID}`);
  }

  public getCompanyHeirarchy() {
    return this._http.get(`${this.config.ServerApiUrl}/organization/getHeirarchy`);
  }

  public getIndivudalCompanyHeirarchy(asscIDs) {
    return this._http.post(`${this.config.ServerApiUrl}/associate/getHeirarchy`,{ids: asscIDs});
  }

  public getSubsidiariesOrganization(selectedOrganizations, organizations) {
    let organizationParentHash = {};
    organizations.forEach(element => {
      organizationParentHash[element._id] = element.company.parentCompany.id;
  });
    let subsidiaries = [],
    tempSub = [];
    let counter = 0;
    do {
        counter++;
        if (counter > 50) {
            break;
        }
        for (let org in organizationParentHash) {
            if (organizationParentHash.hasOwnProperty(org)) {
                for (let i = 0 ; i < selectedOrganizations.length; i ++ ) {
                    if (organizationParentHash[org] === selectedOrganizations[i]) {
                        tempSub.push(org);
                    }
                }

            }
        }
        selectedOrganizations = [];
        selectedOrganizations = tempSub;
        subsidiaries = subsidiaries.concat(tempSub);
        tempSub = []
    } while (selectedOrganizations.length > 0)
    return subsidiaries;
}

}
